import { UseMutateFunction } from '@tanstack/react-query';
import React from 'react';
import type { PropsWithChildren } from 'react';
import { FieldValues } from 'react-hook-form';
import { AnyObjectSchema } from 'yup';

import { FormSheet } from '@/components/FormSheet';

interface Props<T extends FieldValues> {
    title: string;
    editing?: boolean;
    formSchema?: AnyObjectSchema;
    defaultValues?: T;
    onSubmit: UseMutateFunction<any, any, T>;
    pending: boolean;
    onClose: () => void;
}

export const BillingDrawer = <T extends FieldValues>({
    title,
    editing,
    formSchema,
    defaultValues,
    onSubmit,
    pending,
    onClose,
    children,
}: PropsWithChildren<Props<T>>) => (
    <FormSheet
        title={title}
        onClose={onClose}
        onSubmit={(data: T, close) => onSubmit(data, { onSuccess: close })}
        formSchema={formSchema}
        defaultValues={defaultValues}
        pending={pending}
        submitLabel={editing ? 'Save' : 'Create'}
    >
        {children}
    </FormSheet>
);
